import React, { useState, useEffect } from "react";
import "assets/scss/partials/authentication.scss";
import "assets/scss/base/custom.scss";
import logo from "assets/img/reteam_logo.png";
import CustomInput from "components/CustomInput/CustomInput";
import { Link, useHistory } from "react-router-dom";
import CustomButton from "components/CustomButton";
import * as microsoftTeams from "@microsoft/teams-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { useUserContext } from "store/contexts/userContext";
import AuthService from "services/AuthService";
import { useCredentialsContext } from "store/contexts/credentialsContext";
import Loader from "components/Loader";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useGlobalContext } from "store/contexts/globalContext";

export default () => {
  const [errorMessage, setErrorMessage] = useState("");
  const { setIsAuthenticated } = useUserContext();
  const { setCredentials } = useCredentialsContext();
  const [loading, setLoading] = useState(false);
  const { ringCentral, redirectUrl, microsoftConfigureTab } =
    useGlobalContext();
  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });
  const history = useHistory();
  const passwordStyle = {
    marginTop: "0.5rem",
  };

  useEffect(() => {
    microsoftTeams.app.initialize();
    microsoftTeams.app.notifySuccess();

    //eslint-disable-next-line
  }, []);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validateOnBlur: false,
    validationSchema: loginValidationSchema(),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const {
          data: { data: userData },
        } = await AuthService.login(values);

        setLogin(userData);
        setLoading(false);
        if (
          microsoftConfigureTab?.entityId &&
          microsoftConfigureTab?.frameContext === "content"
        ) {
          history.push(
            `/teams/${parseInt(microsoftConfigureTab?.entityId)}/timeline`
          );
        }

        if (ringCentral) {
          history.push(`${redirectUrl}`);
        }
      } catch (error) {
        if (error.response.data.status === 412) {
          setErrorState(
            "Your request for access is in review, One of our representatives will contact you."
          );
        }

        if (error.response.status === 403) {
          setCredentials({
            email: values.email,
          });

          history.replace("/verify-account");
          return;
        }

        if (error.response.data.status !== 412) {
          setErrorState(error.response.data.message);
        }
      }
      setLoading(false);
    },
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const setErrorState = (message) => {
    setErrorMessage(message);
    setTimeout((_) => {
      setErrorMessage("");
    }, 4000);
  };

  const setLogin = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("token", user.token);
    setIsAuthenticated(true);
  };

  return (
    <div className="root" id="user_login">
      <div className="inputBox">
        <div className="login_logo textcenter">
          <img className="logo" alt="ReTeam Logo" src={logo} />
        </div>
        <div className="content">
          <div className="textcenter heading">Login To Continue</div>
          <div className="formContent">
            <form noValidate onSubmit={formik.handleSubmit}>
              <div className="inputFields">
                <CustomInput
                  id={"email"}
                  startIcon={
                    <FontAwesomeIcon icon={faEnvelope} className="formIcon" />
                  }
                  inputProps={{
                    type: "email",
                    placeholder: "Enter Your Email",
                    ...formik.getFieldProps("email"),
                    error:
                      !!formik.errors.email && !!formik.touched.email
                        ? formik.errors.email
                        : null,
                  }}
                />
                <CustomInput
                  id={"password"}
                  startIcon={
                    <FontAwesomeIcon icon={faLock} className="formIcon" />
                  }
                  inputProps={{
                    type: values.showPassword ? "text" : "password",
                    placeholder: "Enter Your Password",
                    ...formik.getFieldProps("password"),
                    error:
                      !!formik.errors.password && !!formik.touched.password
                        ? formik.errors.password
                        : null,
                  }}
                  style={passwordStyle}
                  endIcon={
                    <FontAwesomeIcon
                      onClick={handleClickShowPassword}
                      aria-label="toggle password visibility"
                      icon={!values.showPassword ? faEyeSlash : faEye}
                      id="togglePassword"
                      style={{ marginLeft: "-30px", cursor: "pointer" }}
                    />
                  }
                />
                {errorMessage && (
                  <div className="errorMessage">{errorMessage}</div>
                )}
              </div>
              <div className="checkbox">
                <label>
                  <input type="checkbox" name="remember" className="remember" />
                  Remember Me
                </label>
                <label className="right">
                  Forgot Your <Link to="/forgot-password">Password?</Link>
                </label>
              </div>
              <CustomButton
                name={
                  !loading ? "Sign In Now" : <Loader width={40} height={40} />
                }
                disabled={loading && true}
              />
            </form>
            <div className="textcenter">
              Don't have an account yet?{" "}
              <Link to="/register">Sign Up Now </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const loginValidationSchema = () => {
  return Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string().min(4).required(),
  });
};
